import React from 'react';
import type {SystemHealthStatus} from 'services/healthcheck/types';
import {useLocalization} from 'localization';
import {ColorPalette} from 'theme';
import {FlexBox} from 'components/layout';
import {Text} from 'components/text';

type Props = {
  status: SystemHealthStatus;
};

export const HealthTitle: React.FC<Props> = ({status}) => {
  const {t} = useLocalization();
  const title = t(`system.health.${status}.title`);
  return (
    <FlexBox horizontal left center>
      {/* <HealthIndicator status={status} size="medium" />
      <Spacer width={1} /> */}
      <Text variant="body1" sx={{color: ColorPalette.offWhite}}>
        {title}
      </Text>
    </FlexBox>
  );
};
